import React, { useState } from "react";
import { Helmet } from "react-helmet";
import toast from "react-hot-toast";
import { MdRemoveRedEye } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import signUpUser from "../lib/signUpUser";

type FormData = {
  name: string;
  email: string;
  password: string;
};

function SignUp() {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState<FormData>({
    name: "",
    email: "",
    password: "",
  });

  const { name, email, password } = formData;
  const navigate = useNavigate();

  const validInput = (): boolean => {
    if (password.length < 6) {
      toast.error("Password must be 6 characters or more");
      return false;
    }
    return true;
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (validInput()) {
      setLoading(true);
      try {
        await signUpUser(name, email, password);
        toast.success("Signed up!");
        navigate("/");
      } catch (error) {
        toast.error("Something went wrong!");
        console.log(error);
      }
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <div className="mx-auto my-auto">
          <Loader />
        </div>
      ) : (
        <main className="max-w-md mx-auto">
          <Helmet>
            <title>ScriptOwl | Sign Up</title>
          </Helmet>
          <h1 className="page-title">Create your account!</h1>
          <form onSubmit={onSubmit} className="flex flex-col">
            <input
              type="text"
              className="form-input"
              placeholder="Name"
              id="name"
              value={name}
              onChange={onChange}
              autoComplete="off"
            />
            <input
              type="email"
              className="form-input"
              placeholder="Email"
              id="email"
              value={email}
              onChange={onChange}
              autoComplete="off"
            />
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                className="form-input"
                placeholder="Password"
                id="password"
                value={password}
                onChange={onChange}
                autoComplete="off"
              />
              <button
                type="button"
                className="top-2 right-2 absolute"
                onClick={() => setShowPassword((prevState) => !prevState)}
              >
                <MdRemoveRedEye className="text-2xl" />
              </button>
            </div>

            <button type="submit" className="btn-primary-md mt-4">
              Sign Up
            </button>
          </form>

          <Link
            to="/sign-in"
            className="mt-4 text-primary font-bold flex justify-center"
          >
            Sign In Instead
          </Link>
          <Link
            to="/forgot-password"
            className="text-gray-400 text-sm flex justify-center mt-4"
          >
            Forgot your password?
          </Link>
        </main>
      )}
    </>
  );
}

export default SignUp;
